import { render, staticRenderFns } from "./CardReschedule.vue?vue&type=template&id=6f3fa900"
import script from "./CardReschedule.vue?vue&type=script&lang=js"
export * from "./CardReschedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports